import { get } from "lodash";
import { takeEvery } from "redux-saga/effects";
import {
  fetchOrganizationSets,
  fetchOrganizationSetsStart,
  fetchOrganizationSetsSuccess,
  fetchOrganizationSetsFailure,
} from "@/store/slices/organizationSets";
import { fetcherForSagas } from "@/store/fetcherForSagas";
import { requestOrgSetsData } from "@/features/assessments/api/requests";

function* organization_sets() {
  yield takeEvery(
    fetchOrganizationSets,
    fetcherForSagas({
      start: fetchOrganizationSetsStart,
      success: fetchOrganizationSetsSuccess,
      failure: fetchOrganizationSetsFailure,
      request: ({ payload }: any) => {
        const orgId = Number(payload.organization_id);
        const params: Record<string, any> = {};

        // Filter payload to the params we'll allow to be sent from here.
        params.set_id = get(payload, "set_id", "");

        // Hardcode pagination values (no need to support more flexibility).
        params.page = 1;
        params.per_page = 500;

        return requestOrgSetsData(orgId, params);
      },
    })
  );
}

export default organization_sets;
